import { useUser } from './useUser';

/**
 * Returns true if the current user has access to the given section.
 * If the user has no hideSections config (e.g. owner or no restrictions), defaults to true.
 */
const useHasAccess = (sectionKey: string): boolean => {
  const { user } = useUser();
  if (!user?.hideSections) return true;
  return !user.hideSections[sectionKey];
};

export default useHasAccess;
